import { GenericCrudPage } from '@/components/GenericCrudPage';
import { scoringConfig } from '@/pages/configs';

export default function ScoringPage() {
  return <GenericCrudPage config={scoringConfig} />;
}
